<template>
  <footer>
    <div class="flex justify-around items-stretch footer_spacing wrap mobile_padding">
      <div class="column md-col-4 sm-col-6 col-12 justify-between footer_mobile">
        <div class="petit_logo_container">
          <img src="/images/logo.png" alt="logo" id="bottom_logo" class="petit_logo"/>
        </div>
        <span style="line-height: 24px;">7 rue Jeanne d'Arc<br>78100 Saint Germain-en-Laye<br>{{$store.state.translations.tel}}: 01 83 62 49 10</span>
        <span class="foot_title"><img src="/images/transports.png" alt="Transports" style="width: 150px; max-width: 100%;"/></span>
      </div>
      <a href="mailto:contact@ddf-piranha.fr" class="m2 desktop_hide"><span class="subtitle center_subtitle">{{$store.state.translations.nous_contacter}}</span></a>
      <div class="column md-col-4 sm-col-6 col-12 caps justify-between tablet_hide">
        <router-link :to="{name: 'expertise'}" class="foot_title line_bottom" style="padding-top: 0;">{{$store.state.translations.menu_agence}}</router-link>
        <router-link :to="{name: 'portfolio'}" class="foot_title line_bottom">{{$store.state.translations.menu_expertises}}</router-link>
        <router-link :to="{name: 'rgpd'}" class="foot_title line_bottom">{{$store.state.translations.menu_traitement_de_la_reglementation_rgpd}}</router-link>
        <router-link :to="{name: 'conditions-generales'}" class="foot_title line_bottom">{{$store.state.translations.menu_conditions_generales}}</router-link>
        <router-link :to="{name: 'mentions-legales'}" class="foot_title line_bottom">{{$store.state.translations.menu_mentions_legales}}</router-link>
      </div>
      <div class="column md-col-4 sm-col-6 col-12 justify-between">
        <span class="foot_title caps mobile_hide">{{$store.state.translations.tags}}</span>
        <div class="foot_title flex-auto border_mobile">
          <span class="tag" v-for="(tag, i) in tags" :key="i">{{tag}}</span>
        </div>
      </div>
    </div>
    <div class="flex justify-between mx3 my3 caption_mobile">
      <a href="mailto:contact@ddf-piranha.fr" class="mobile_hide"><span class="subtitle">{{$store.state.translations.nous_contacter}}</span></a>
      <div class="legend-footer">
        <span class="caption">{{$store.state.translations.pirahna_communication_est_une_marque_deposee}}</span>
        <span class="pl3 caption">
          {{$store.state.translations.lagence_piranha_fait_partie_du_groupe_ddf}}
          <span><img src="/images/ddf.png" alt="Logo DDF" style="max-width: 20px; vertical-align: -5px; padding-left: 4px;"/></span>
        </span>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="stylus">
@import '../css/variables'

.legend-footer
  @media mobile
    display flex
    justify-content space-between
    align-items baseline
    width 100%
</style>

<script>
export default {
  computed: {
    tags () {
      return this.$store.state.translations.liste_tags ? this.$store.state.translations.liste_tags.split('\n') : [];
    }
  }
}
</script>